exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selector select[data-v-7e700450]{opacity:1}input[data-v-7e700450]:focus{outline:none}.selector select:focus+.custom-select[data-v-7e700450],input.input-text[data-v-7e700450]:focus,textarea[data-v-7e700450]:focus{outline:none;border:1px solid #d3e4f7;box-shadow:0 0 8px #d3e4f7}input.input-text.invalid[data-v-7e700450]{border:1px solid red;background-color:#fdecf8}.selector select.invalid[data-v-7e700450]{border:1px solid red}.errormsg[data-v-7e700450]{margin-bottom:3px;margin-top:3px;color:red}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-7e700450]{font-size:1.6em}.booking-section[data-v-7e700450]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e700450","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/complaints/Home.vue
// module id = 602
// module chunks = 0